<template>
  <div id="app">
    <router-view/>
    <backtop></backtop>
  </div>
</template>

<script>
import backtop from "./components/backtop"
export default {
  components: {
    backtop
  },
  name: 'App',
  methods: {
   
  }
}
</script>

<style>
#app {
  font-family:'PingFang SC', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
::-webkit-scrollbar {
  width: 0 !important;
}
::-webkit-scrollbar {
  width: 0 !important;
  height: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue